import { getUrl } from './utils'

export const episodes = [
  {
    id: 1,
    text: (
      <p>
        В первой серии проекта &quot;За нашу Свободу&quot; журналисты русской
        службы рассказывают о жизни Радио Свобода на рубеже XX – XXI веков.
        Радио Свобода перестают глушить в России. В 1991-м в Москве открывается
        корпункт русской службы. Два года спустя президент США Билл Клинтон
        принимает решение закрыть радиокорпорацию. &quot;Свободе&quot;
        соглашается помочь президент Чехии Вацлав Гавел, и РСЕ/РС переезжает в
        Прагу.
      </p>
    ),
    img: getUrl('/images/videos/1_episodes/episode_1.jpg'),
    youtube: 'FOw5gNjRrBE',
  },
  {
    id: 2,
    text: (
      <p>
        Второй эпизод – это рассказ о том, как события 2000-х повлияли на
        мировую историю и жизни журналистов РС. В прямом эфире радиостанция
        следит за терактами в США 11 сентября 2001 года. Штаб-квартиру РСЕ/РС в
        Праге берут под охрану. В 2002-м в Москве – теракт в Театральном центре
        на Дубровке. Сотрудники РС ведут трехдневный эфир с места событий.
        Власти путинской России лишают &quot;Свободу&quot; возможности вещать на
        ультракоротких волнах.
      </p>
    ),
    img: getUrl('/images/videos/1_episodes/episode_2.jpg'),
    youtube: 'u0rVeg4psGQ',
  },
  {
    id: 3,
    text: (
      <p>
        В третьей серии проекта &quot;За нашу свободу&quot; журналисты РС
        рассказывают о жизни редакции в 2010-х. Директором русской службы на
        несколько месяцев становится Маша Гессен. В Москве руководство проводит
        массовые увольнения сотрудников. &quot;Свобода&quot; меняет стратегию
        работы и уходит в интернет. Давление со стороны российских властей
        усиливается. Россия начинает войну на востоке Украины. Журналисты РС
        ведут репортажи из зоны боевых действий. Радио Свобода признают
        &quot;иноагентом&quot; в России.
      </p>
    ),
    img: getUrl('/images/videos/1_episodes/episode_3.jpg'),
    youtube: 'wLN6cJGlv5k',
  },
  {
    id: 4,
    text: (
      <p>
        Четвертый эпизод рассказывает о запрете &quot;Свободы&quot; в РФ и
        работе редакции после закрытия бюро в Москве. В феврале 2022 года Россия
        развязывает полномасштабную войну против Украины. Радио освещает
        вторжение в Украину, не подчиняясь военной цензуре. Сайты
        &quot;Свободы&quot; и аккаунты в социальных сетях в РФ блокируют.
        Журналистов, работавших в Москве, переводят в Ригу. После выборов
        президента США 2024 года Агентство по глобальным медиа (попечитель Радио
        Свобода) заявляет об отзыве гранта у РСЕ/РС.
      </p>
    ),
    img: getUrl('/images/videos/1_episodes/episode_4.jpg'),
    youtube: 'q9iZdT1B5cs',
  },
  {
    id: 5,
    text: (
      <p>
        В заключительной серии проекта &quot;За нашу свободу&quot; сотрудники
        русской службы Радио Свобода говорят о будущем РС, о российской
        госпропаганде, бороться с которой становится все сложнее и о том, что
        &quot;Свобода&quot; значит для них самих.
      </p>
    ),
    img: getUrl('/images/videos/1_episodes/episode_5-inactive.jpg'),
  },
]
